<template>
    <div id="userList">
        <div class="searchContent" id="search">
            <div class="p_select search_day_list">
                <div class="search_label">查询日期</div>
                <div @mouseover="onMouseOver('start')" @mouseleave="onMouseleave('start')">
                    <el-date-picker
                            v-model="queryStartTime"
                            type="date"
                            value-format="timestamp"
                            :picker-options="pickerDayOptions"
                            prefix-icon="''"
                            class="datepicker"
                            @change="getCountSoldDetail"
                            placeholder="选择开始日期">
                    </el-date-picker>
                    <i class="el-icon-date" ref="iconDateStart"></i>
                </div>
            </div>
            <div class="p_select search_day_list">
                <div @mouseover="onMouseOver('end')" @mouseleave="onMouseleave('end')">
                    <el-date-picker
                            v-model="queryEndTime"
                            type="date"
                            value-format="timestamp"
                            :picker-options="pickerDayOptions"
                            prefix-icon="''"
                            class="datepicker"
                            @change="getCountSoldDetail"
                            placeholder="选择结束日期">
                    </el-date-picker>
                    <i class="el-icon-date" ref="iconDateEnd"></i>
                </div>
            </div>
            <div class="p_select">
                <el-button class="search_btn" @click="getCountSoldDetail">查询</el-button>
                <el-button class="add_btn" @click="exportTable">导出</el-button>
            </div>
        </div>
        <div class="table">
            <el-table :data="countSoldDetailData" ref="table_3" id="countSoldDetailTable" :span-method="objectSpanMethod" :cell-style="cellStyle" :header-cell-style="tableHeaderColor" show-summary :summary-method="getSummaries">
                <el-table-column prop="id" label="检测部位id" align="left"></el-table-column>
                <el-table-column prop="name" label="检测项目" align="left"></el-table-column>
                <el-table-column prop="intExtra1" label="总检测台次" align="left" width="150"></el-table-column>

                <el-table-column prop="detected" label="已检测" align="left" sortable></el-table-column>
                <el-table-column label="单项检测渗透率" align="left" :sortable="true" sort-by="singleDetectionRate">
                    <template slot-scope="scope">
                        <span>{{scope.row.singleDetectionRate==0?"-": (scope.row.singleDetectionRate+"%")}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="normal" label="检测正常" align="left" sortable></el-table-column>
                <el-table-column prop="abnormal" label="检测异常" align="left" sortable></el-table-column>
                <el-table-column label="异常占比" align="left" :sortable="true" sort-by="abnormalRate">
                    <template slot-scope="scope">
                        <span>{{scope.row.abnormalRate==0?"-": (scope.row.abnormalRate+"%")}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="saleData" label="已销售" align="left" sortable></el-table-column>

                <el-table-column label="前台前置检出项目成交率" align="left" :sortable="true" sort-by="receptionNumRate">
                    <template slot-scope="scope">
                        <span>{{scope.row.receptionNumRate==0?"-": (scope.row.receptionNumRate+"%")}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="车间增项检出项目成交率" align="left" :sortable="true" sort-by="workshopNumRate">
                    <template slot-scope="scope">
                        <span>{{scope.row.workshopNumRate==0?"-": (scope.row.workshopNumRate+"%")}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="整体检出项目成交率" align="left" :sortable="true" sort-by="turnoverRate">
                    <template slot-scope="scope">
                        <span>{{scope.row.turnoverRate==0?"-": (scope.row.turnoverRate+"%")}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
  import net from "../../assets/js/public";
  import XLSX from "xlsx";
  import FileSaver from "file-saver";
  export default {
    name: "salesDealSummany",
    data(){
      return {
        queryStartTime:'',
        queryEndTime:'',
        countSoldDetailData:[],
        winHeight:'200',
        pickerDayOptions: { // 按天 当天、当月可选
          disabledDate(time) {
            return time.getTime() > Date.now() + 1 * 24 * 60 * 60 * 1000;
          }
        },

        receptionNumSum :0,
        workshopNumSum :0,
        turnoverSum :0,
      }
    },
    created() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      if(signInfo.orgId > 0){
        this.orgId = signInfo.orgId
      }

      let obj = new Date();
      let month = obj.getMonth() + 1;
      if (month < 10) month = "0" + month;

      this.queryStartTime = new Date(obj.getFullYear() + "-" + month + "-01").getTime();


      let after = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)//后一天
      let afterMonth = after.getMonth() + 1;
      if (afterMonth < 10) afterMonth = "0" + afterMonth;
      let afterDay = after.getDate()
      if (afterDay < 10) afterDay = "0" + afterDay;

      this.queryEndTime = new Date(after.getFullYear() + "-" + afterMonth + "-" + afterDay).getTime();

      this.getCountSoldDetail()

    },
    methods: {
      onMouseOver(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'none';
        }else {
          this.$refs.iconDateEnd.style.display = 'none';
        }
      },
      onMouseleave(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'block';
        }else {
          this.$refs.iconDateEnd.style.display = 'block';
        }
      },
      // 表头样式
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return "background-color:#F3F7FB; color: #364556; text-align: left;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
      },
      cellStyle({ row, column, rowIndex, columnIndex }) {
        if(row.columnIndex == 0){
          return 'color: #0D0E12;font-weight: 500;font-size: 14px;'
        }else if(columnIndex == 2){
          return 'color: #0D0E12;font-weight: 400;text-align: center;'
        }else{
          return 'color: #0D0E12;font-weight: 400;'
        }
      },
      // 合并列
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 2 ) {
          if (rowIndex  === 0) {
            this.$nextTick(() => {
              this.$refs['table_3'].doLayout();
            })
            return {
              rowspan: this.countSoldDetailData.length,
              colspan: 1
            };
          }else {
            return [0, 0]
          }
        }
      },
      //合计栏列
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index === 1 || index === 2) {
            sums[index] = '-';
            return;
          }
          if (index === 9 ) {
            sums[index] = this.receptionNumSum >0 && sums[6] >0 ? ((this.receptionNumSum / sums[6]) *100).toFixed(2)*1+'%' : '-';
            return;
          }
          if (index === 10 ) {
            sums[index] = this.workshopNumSum >0 && sums[6] >0 ? ((this.workshopNumSum / sums[6]) *100).toFixed(2)*1+'%' : '-';
            return;
          }
          if (index === 11 ) {
            sums[index] = this.turnoverSum >0 && sums[6] >0 ? ((this.turnoverSum / sums[6]) *100).toFixed(2)*1+'%' : '-';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = '-';
          }
        });
        return sums;
      },
      // 销售数据整理
      getCountSoldDetail(){
        const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
        if (this.queryStartTime === "" || this.queryStartTime === null || this.queryEndTime === "" || this.queryEndTime === null ) {
          this.$message({
            message: "请选择查询日期区间",
            type: 'warning',
            duration:2000,
            offset:windiwHight/2
          });
          return;
        }
        const params = {
          // orgId: this.orgId || 0,
          queryStartTime: this.queryStartTime,
          queryEndTime: this.queryEndTime
        }
        net.request("admin/manage/report/countSoldDetail", "post", params, null).then(res => {
          if (res.code == 0) {
            // net.message(this, "查询成功", "success");
            let data = res.data
            let intExtra1 = res.extra1 // 检测台次
            let receptionNumSum = 0
            let workshopNumSum = 0
            let turnoverSum = 0
            data.forEach(item => {
              item.intExtra1 = intExtra1
              item.detected = item.normal + item.abnormal //已检测（normal+abnormal）
              item.singleDetectionRate = intExtra1>0 ? (((item.normal + item.abnormal)/intExtra1) *100).toFixed(2)*1 : 0 //单项检测渗透率（已检测/台次）
              item.abnormalRate = (item.normal + item.abnormal)>0 ? ((item.abnormal / (item.normal + item.abnormal)) *100).toFixed(2)*1 : 0 //异常占比（abnormal  /已检测（normal+abnormal））
              item.turnoverRate = item.abnormal >0 ? ((item.abnormalSold+ item.normalSold) / item.abnormal *100).toFixed(2)*1 : 0 //成交率（abnormalSold +normalSold /  已检测 ）

              item.receptionNumRate = item.receptionNum >0 && item.abnormal >0 ? ((item.receptionNum / item.abnormal) *100).toFixed(2)*1 : 0 //
              item.workshopNumRate = item.workshopNum >0 && item.abnormal >0 ? ((item.workshopNum / item.abnormal) *100).toFixed(2)*1 : 0 //

              item.saleData = item.abnormalSold + item.normalSold //已销售

              receptionNumSum += item.receptionNum*1
              workshopNumSum += item.workshopNum*1
              turnoverSum += (item.abnormalSold*1 + item.normalSold*1)
            })
            this.countSoldDetailData = data
            this.receptionNumSum = receptionNumSum
            this.workshopNumSum = workshopNumSum
            this.turnoverSum = turnoverSum
            this.winHeight = windiwHight  - 190
            this.$nextTick(() => {
              this.$refs['table_3'].doLayout();
            })

            this.$message({
              message: '查询成功',
              type: 'success',
              duration:2000,
              offset:windiwHight/2
            });
          } else {
            net.message(this, res.msg, "warning");
            this.$message({
              message: res.msg,
              type: 'warning',
              duration:2000,
              offset:windiwHight/2
            });
          }
        })
      },
      // 导出数据
      exportTable() {
        // let elTableId = ''
        // if(this.activeName === 'third'){
        //   elTableId = '#countSoldDetailTable'
        // }
        var wb = XLSX.utils.table_to_book(document.querySelector('#countSoldDetailTable'));
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            "销售成交统计.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
      },


      //监听键盘Esc按键事件
      handleKeyup(event){
        let self = this;
        const e = event || window.event || arguments.callee.caller.arguments[0]
        if(!e) return
        if (e.keyCode == 27) {
          let routeNmae = self.$route.name
          if(routeNmae != 'OperationDataStatistics'){
            e.stopImmediatePropagation();
            self.$router.replace({ name: 'OperationDataStatistics' })
          }
        }
      },

    },
    mounted() {
      window.addEventListener('keyup',this.handleKeyup)
    },
    beforeDestroy() {
      window.removeEventListener('keyup',this.handleKeyup)
    }
  };
</script>

<style lang="less" scoped>
    #userList {
        display: flex;
        flex-direction: column;
        margin: 24px 0 0 24px;
        background: #fff;
        padding-left: 24px;
        padding-bottom: 10px;

        .searchContent {
            height: 40px;
            background: #fff;
            /*margin: 24px 0 0px 0;*/
            /*display: flex;*/
            /*flex-direction: row;*/
            /*padding-left: 24px;*/
            padding-top: 9px;
            margin-bottom: 24px;
            /*display: flex;*/
            .p_select {
                display: flex;
                margin-right: 24px;
                font-size: 12px;
                float: left;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
            .search_btn {
                /*width: 76px;*/
                height: 36px;
                background: #2B54FC;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 14px;
            }
            .add_btn {
                /*width: 76px;*/
                height: 36px;
                background: rgba(148, 170, 204, 0.08);
                border: 1px solid #2B54FC;
                border-radius: 4px;
                font-size: 14px;
                color: #2B54FC;
            }

            .option_box{
                margin-bottom: 24px;
                display: flex;
                .option_item {
                    width: 200px;
                    height: 36px;
                    margin-right: 12px;
                    background: #FFFFFF;
                    box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                    border-radius: 4px;
                    text-align: center;
                    line-height: 36px;
                    font-weight: 400;
                    font-size: 14px;
                    text-align: center;
                    color: #364556;
                }
                .option_active {
                    background: #2B54FC;
                    color: #FFFFFF;
                    font-weight: 500;
                }
            }
            .option_item_box{
                margin-bottom: 24px;
                display: flex;
                .item_ {
                    height: 36px;
                    margin-right: 12px;
                    background: #FFFFFF;
                    box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                    border-radius: 4px;

                    line-height: 36px;
                    padding: 0 24px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #364556;
                }
                .item_active {
                    background: #2B54FC;
                    color: #FFFFFF;
                    font-weight: 500;
                }
            }

        }
        .list_content {
            background: #fff;
            padding-left: 24px;
            padding-right: 24px;
        }

        .pagination {
            position: relative;
            margin-top: 0;
            background: #fff;
            padding-top: 24px;
            padding-bottom: 10px;
            .el-pagination {
                position: absolute;
                right: 24px;
                .el-pager li:not(.disabled) {
                    .active {
                        background: #009688 !important;
                    }
                }
            }
        }
    }
</style>

